module.exports = __webpack_public_path__ + "img/sixth.b941c5a9.png";